import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useSelector } from "react-redux";
import useFlash from "go-alert/AlertMessage";
import handleError from "go-app/services/errors";
import { useBrowserTabTitle } from "go-core/components/BrowserTab/useBrowserTabTitle";
import { LoadingContainer } from "go-core/components/Loading";
import { organizationApi } from "../../../../../../../../../../services/Api/Organization/organizationApi";
import { OrganizationMeApi } from "../../../../../../../../../../services/Api/types";
import { selectOrganization } from "../../../../../../../../../../services/organizations/selectors";
import InvoiceDetailsForm from "../../../../../../../../components/InvoiceDetails/InvoiceDetailsForm";

const OrganizationSettingsPageInvoiceDetailsPage = () => {
	const [details, setDetails] = useState<OrganizationMeApi | undefined>(undefined);
	const organization = useSelector(selectOrganization);
	const { addFlash } = useFlash();
	const { handleChangeTabTitle } = useBrowserTabTitle();
	const { t } = useTranslation();

	useEffect(() => {
		handleChangeTabTitle(t("modules.settings.field.invoice_details.title"));
		fetchOrganizationMeDetails();
	}, []);

	const fetchOrganizationMeDetails = async () => {
		try {
			if (organization && organization.id) {
				const res = await organizationApi.getOrganizationMe(organization.id);
				setDetails(res);
			}
		} catch (err) {
			handleError.alert(err, addFlash);
		}
	};

	return details ? <InvoiceDetailsForm details={details} isModalForm={false} /> : <LoadingContainer />;
};

export default OrganizationSettingsPageInvoiceDetailsPage;
